import React from 'react';
import { Container, Row, Col } from 'mdbreact';
import Lightbox from 'react-image-lightbox';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

// import assets (for WebPack) - temporary location for now
import image_active_interest from 'assets/photos/photo_active_interest.jpg';
import image_between_two_worlds from 'assets/photos/photo_between_two_worlds.jpg';
import image_shine_here_to_us from 'assets/photos/photo_shine_here_to_us.jpg';
import image_steady from 'assets/photos/photo_steady.jpg';
import image_lonely_submarine from 'assets/photos/photo_lonely_submarine.jpg';
import image_tinge_glow from 'assets/photos/photo_tinge_glow.jpg';
import image_solitude from 'assets/photos/photo_solitude.jpg';
import image_morning from 'assets/photos/photo_morning.jpg';
import image_flash_in_the_night from 'assets/photos/photo_flash_in_the_night.jpg';

import thumb_active_interest from 'assets/photos/thumb_active_interest.jpg';
import thumb_between_two_worlds from 'assets/photos/thumb_between_two_worlds.jpg';
import thumb_shine_here_to_us from 'assets/photos/thumb_shine_here_to_us.jpg';
import thumb_steady from 'assets/photos/thumb_steady.jpg';
import thumb_lonely_submarine from 'assets/photos/thumb_lonely_submarine.jpg';
import thumb_tinge_glow from 'assets/photos/thumb_tinge_glow.jpg';
import thumb_solitude from 'assets/photos/thumb_solitude.jpg';
import thumb_morning from 'assets/photos/thumb_morning.jpg';
import thumb_flash_in_the_night from 'assets/photos/thumb_flash_in_the_night.jpg';


require('mdbreact/docs/pages/pro/Lightbox.css');

const images = [
  { asset_image: image_active_interest,
    asset_thumb: thumb_active_interest,
    title: 'Active Interest'
  },
  { asset_image: image_between_two_worlds,
    asset_thumb: thumb_between_two_worlds,
    title: 'Between two worlds'
  },
  { asset_image: image_shine_here_to_us,
    asset_thumb: thumb_shine_here_to_us,
    title: 'Shine here to us'
  },
  { asset_image: image_steady,
    asset_thumb: thumb_steady,
    title: 'Steady'
  },
  { asset_image: image_lonely_submarine,
    asset_thumb: thumb_lonely_submarine,
    title: 'Lonely submarine'
  },
  { asset_image: image_tinge_glow,
    asset_thumb: thumb_tinge_glow,
    title: 'Tinge\'s glow'
  },
  { asset_image: image_flash_in_the_night,
    asset_thumb: thumb_flash_in_the_night,
    title: 'Flash in the night'
  },
  { asset_image: image_morning,
    asset_thumb: thumb_morning,
    title: 'Morning'
  },
  { asset_image: image_solitude,
    asset_thumb: thumb_solitude,
    title: 'Solitute'
  }
];

class PagePhoto extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isAssetOpened: false
    };
  }

  static get propTypes() {
    return {
      propTitle: PropTypes.string,
      onActivated: PropTypes.func
    };
  }

  componentDidMount() {
    console.log(`PagePhoto::componentDidMount with props: ${this.props}`);
    console.log(this.props);
    this.props.onActivated(this.props.propTitle);
  }

  render() {
    const { photoIndex, isAssetOpened } = this.state;
    return (
      <Container className="mt-5">
        <div className="mdb-lightbox no-margin">
          <Row>
            <Col md="4">
              <figure>
                <img src={images[0].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 0, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[1].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 1, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[2].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 2, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[3].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 3, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[4].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 4, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[5].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 5, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[6].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 6, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[7].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 7, isAssetOpened: true })} />
              </figure>
            </Col>
            <Col md="4">
              <figure>
                <img src={images[8].asset_thumb} alt="Gallery" className="img-fluid" onClick={() => this.setState({ photoIndex: 8, isAssetOpened: true })} />
              </figure>
            </Col>
          </Row>
        </div>
        {isAssetOpened && (
          <Lightbox
            mainSrc={images[photoIndex].asset_image}
            nextSrc={images[(photoIndex + 1) % images.length].asset_image}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].asset_image}
            imageTitle={images[photoIndex].title}
            onCloseRequest={() => this.setState({ isAssetOpened: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Container>
    );
  }
}

export default withRouter(PagePhoto);



// WEBPACK FOOTER //
// ./src/Pages/Photo/page-photo.js